module.exports = __webpack_public_path__ + "img/especialista22.8291a0d9.png";